module.exports = __webpack_public_path__ + "static/media/1.5af29dda.JPG";